export default "__VITE_ASSET__C2NUWT$Q__"